module.exports = __webpack_public_path__ + "static/media/magic_rule_not_pressed_button.8790a10f.png";